var _rect, _rect2, _circle, _line, _path, _line2, _path2, _path3, _path4, _path5, _path6, _line3, _path7, _path8, _path9, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTemplateBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddTemplate_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_964",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1180",
    "data-name": "Rectangle 1180",
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    opacity: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(19.82 8.64)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 3.81,
    transform: "translate(8.95 18.11)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M20.39,6.74V6.01a2.221,2.221,0,0,0-2.01-2.23c-.38-.03-.76-.06-1.14-.08",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y1: 3.9,
    x2: 0.01,
    transform: "translate(20.39 11.59)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M11.34,3.71a2.222,2.222,0,0,0-.1.67.76.76,0,0,0,.76.76h4.57a.76.76,0,0,0,.76-.76,2.132,2.132,0,0,0-.1-.67",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M11.33,3.71A2.283,2.283,0,0,1,13.51,2.1h1.52a2.3,2.3,0,0,1,2.19,1.61",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M11.32,3.71c-.38.02-.76.05-1.14.08A2.221,2.221,0,0,0,8.17,6.02V8.2",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M15.81,20.91v-.15",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M15.81,15.49V9.34A1.139,1.139,0,0,0,14.67,8.2H4.74A1.139,1.139,0,0,0,3.6,9.34V20.77a1.139,1.139,0,0,0,1.14,1.14h9.93a1.135,1.135,0,0,0,1.13-.99",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 3.81,
    transform: "translate(8.93 13.05)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M6.64,13.05Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M6.64,18.1Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M18.5,14A4.5,4.5,0,1,0,23,18.5,4.494,4.494,0,0,0,18.5,14Zm1.73,4.85H18.85v1.38a.35.35,0,1,1-.7,0V18.85H16.77a.35.35,0,1,1,0-.7h1.38V16.77a.35.35,0,0,1,.7,0v1.38h1.38a.35.35,0,0,1,0,.7Z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(0.94 1)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTemplateBtnIcon);
export default __webpack_public_path__ + "static/media/add-template-btn-icon.2cc23f55f8ae5ffbffcfce71fe15e1f3.svg";
export { ForwardRef as ReactComponent };